const INCIDENT_REQUEST_SIZE = 20;
export default INCIDENT_REQUEST_SIZE;
